module.exports = __webpack_public_path__ + "img/icon-check.488b9a6d.png";